<div class="global-search-main" (appClickOutside)="onClickOutside()" data-cy="global-search-container">
  <div class="global-search-input-container" data-cy="global-search-input-wrapper">
    <div style="background-color: var(--tdo-primary); padding: 4px; width: 40px; border-top-left-radius: var(--border-radius); border-bottom-left-radius: var(--border-radius);" data-cy="global-search-icon-container">
      <img style="margin-left: 6px;" src="assets/Images/navbar-icons/v2/search.svg" data-cy="global-search-icon">
    </div>
    <div style="flex-basis: 1px; background-color: var(--tdo-primary); height: 100%; margin-left: 2px; margin-right: 2px;" data-cy="global-search-divider"></div>
    <app-tdo-search [executionDelay]="500" (searchChange)="onSearchChange($event)" floatLabel="never" style="flex: 1; width: 100%; position: relative; margin-left: 4px; margin-right: 12px;" data-cy="global-search-input"></app-tdo-search>
  </div>
  @if (patients()?.length > 0) {
    <div data-cy="global-search-patients-header">
      <span style="margin-left: 3px; color: var(--tdo-secondary); font-weight: 500; font-size: 20px;" data-cy="global-search-patients-label">Patients</span>
      <br />
      <div style="display: flex;margin-left: 10px; padding: 2px 4px 2px 4px;" data-cy="global-search-patients-column-headers">
        <div style="flex-basis: 40px; text-align: right;" data-cy="global-search-patient-number-header">#</div>
        <div style="flex: 1; margin-left: 20px;" data-cy="global-search-patient-first-header">First</div>
        <div style="flex: 1" data-cy="global-search-patient-middle-header">Middle</div>
        <div style="flex: 1" data-cy="global-search-patient-last-header">Last</div>
      </div>
    </div>
  }
  @if (patients()?.length > 0) {
    <div class="global-search-content" data-cy="global-search-results-container">
      @if (patients()?.length > 0) {
        <div data-cy="global-search-patients-results">
          <div style="margin-left: auto; margin-right: auto; width: 93%; height: 1px; background-color: var(--tdo-primary)" data-cy="global-search-divider-line"></div>
          @for (patient of patients(); track patient) {
            <div class="search-item" (click)="loadPatient(patient)" data-cy="global-search-patient-item" [ngClass]="{ 'error-background': patient.patient.xauditDeleted}">
              <div style="flex-basis: 40px; text-align: right;" data-cy="global-search-patient-number">{{patient.patient.PatientNO}}</div>
              <div style="flex: 1; margin-left: 20px;" data-cy="global-search-patient-first">{{patient.contact.FirstName}}</div>
              <div style="flex: 1" data-cy="global-search-patient-middle">{{patient.contact?.MidName}}</div>
              <div style="flex: 1" data-cy="global-search-patient-last">{{patient.contact.LastName}}</div>
              <!--{{patient.contact.FirstName + ' ' + patient.contact.MidName + ' ' + patient.contact.LastName}}-->
            </div>
          }
        </div>
      }
    </div>
  }
</div>
